export function stringReplacer(sourceString: string, params: Record<string, string>) {
  return Object.entries(params).reduce((acc, [key, value]) => {
    const rx = new RegExp(`{${key}}`, 'g');
    return acc.replace(rx, value);
  }, sourceString);
}
